module.exports = {
          srcSet: __webpack_public_path__ + "images/1983-2-5756e938253c6e7f51ca33f46ae88bd7-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1983-2-71eb2a5c0099faac91afb355b57ba375-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1983-2-5756e938253c6e7f51ca33f46ae88bd7-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1983-2-71eb2a5c0099faac91afb355b57ba375-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1983-2-5756e938253c6e7f51ca33f46ae88bd7-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1983-2-5756e938253c6e7f51ca33f46ae88bd7-320.jpg"},
          
          width: 320,
          height: 251
        }